/**
 * モーダル、ナビの出現時に背景のスクロール固定
 */

export const bodyScrollFixed = ( isFixed ) => {
	//スクロール固定用ベースstyle
	const styles = {
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		boxSizing: 'border-box',
		paddingRight: 0,
	};
	const body = document.body;

	//スクロール固定
	if ( isFixed ) {
		//style設定
		//const scrollY = window.pageYOffset || document.documentElement.scrollTop;

		const scrollY = 0; //オープニングアニメーションのためスクロール位置記憶しない。常に0
		styles.top = scrollY * -1 + 'px';
		styles.paddingRight =
			window.innerWidth - document.body.clientWidth + 'px';
		Object.keys( styles ).forEach( ( key ) => {
			body.style[ key ] = styles[ key ];
		} );

		//body.classList.add('is-fixed');
	} else {
		//スクロール固定解除

		//スクロール位置取得
		//const scrollY = parseInt( body.style.top || '0' );

		//style解除
		Object.keys( styles ).forEach( ( key ) => {
			body.style[ key ] = '';
		} );
		//body.classList.remove('is-fixed');

		//スクロール位置設定
		//window.scrollTo( 0, scrollY * -1 );
		//オープニングアニメーションのためスクロール位置記憶しない。常に0
		window.scrollTo( 0, 0 );
	}
};

//スクロール固定を発動させるボタン
const fixBtn = document.querySelectorAll( '.js-bsFixed' );
fixBtn.forEach( ( e ) => {
	e.addEventListener( 'click', function () {
		if ( e.classList.contains( 'is-active' ) ) {
			//スクロール停止解除
			bodyScrollFixed( false );

			//メニュー非表示
			//fixBtn.classList.remove('is-active');
		} else {
			//スクロール停止
			bodyScrollFixed( true );

			//メニュー表示
			//fixBtn.classList.add('is-active');
		}
	} );
} );
